import { render, staticRenderFns } from "./dualUseItemClassification.vue?vue&type=template&id=ca5dc1e4&scoped=true"
import script from "./dualUseItemClassification.vue?vue&type=script&lang=js"
export * from "./dualUseItemClassification.vue?vue&type=script&lang=js"
import style0 from "./dualUseItemClassification.vue?vue&type=style&index=0&id=ca5dc1e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5dc1e4",
  null
  
)

export default component.exports